import * as React from "react";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { LSResultItemBookjacket } from "../search/ls/LSResultItem/LSResultItemBookjacket";
import { LSResultItemLayout } from "../search/ls/LSResultItem/LSResultItemLayout";
import { Box, Chip, Typography } from "@mui/material";
import { LSResultItemTitle } from "../search/ls/LSResultItem/LSResultItemTitle";
import { LSResultItemAuthor } from "../search/ls/LSResultItem/LSResultItemAuthor";
import { RatingHighContrast } from "../../rate-and-review/RatingHighContrast";
import { LSSerialIssueInformation } from "./LSSerialIssueInformation";
import { LSResultItemReadingLevelDisplay } from "../search/ls/LSResultItem/LSResultItemReadingLevelDisplay";
import { useLanguage } from "../../Language";
import { GenreDisplay } from "./GenreDisplay";
import { LSResultItemSeries } from "../search/ls/LSResultItem/LSResultItemSeries";
import { useLocalizedShortDate } from "../../../hooks/useLocalizedShortDate";
import { WriteYourReviewButton } from "../../rate-and-review/WriteYourReviewButton";
import { RateAndReview } from "../../rate-and-review/RateAndReview";
import { useMatch } from "react-router-dom";

export const LoanHistoryItem = ({
  loan,
  canRateAndReview,
}: {
  loan: HostSystemItemView;
  canRateAndReview?: boolean;
}) => {
  const { translate } = useLanguage();
  const formatDate = useLocalizedShortDate();
  const {
    resource,
    title,
    author,
    outDate,
    returnedDate,
    enumeration,
    chronology,
  } = loan;

  return (
    <LSResultItemLayout
      titleComponent={
        resource ? (
          <LSResultItemTitle resource={resource} />
        ) : (
          <Typography component="h3" variant="h6" flex={1}>
            {title}
          </Typography>
        )
      }
      bookjacketComponent={
        <LSResultItemBookjacket
          {...(loan.resource
            ? { resource: loan.resource }
            : { title: loan.title })}
        />
      }
      checkboxComponent={undefined}
      actionsComponent={
        canRateAndReview && <WriteYourReviewButton resource={resource} />
      }
      authorComponent={
        <LSResultItemAuthor shortAuthor={resource?.shortAuthor || author} />
      }
    >
      {/* Format label and rating */}
      {resource && (
        <Box display="flex" alignItems="center" gap={2}>
          {resource.format && (
            <Box>
              <Chip variant="outlined" label={resource.format} />
            </Box>
          )}
          {canRateAndReview ? (
            <RateAndReview material={resource} precision={0.5} />
          ) : (
            <RatingHighContrast
              value={resource.ratingInformation?.average}
              readOnly
              precision={0.5}
            />
          )}
        </Box>
      )}
      <LSResultItemSeries resource={resource} />
      <LSSerialIssueInformation
        chronology={chronology}
        enumeration={enumeration}
      ></LSSerialIssueInformation>
      <LSResultItemReadingLevelDisplay resource={resource} />
      <GenreDisplay item={loan} />
      <Typography component={"div"}>
        {translate("checkedOut")}: <strong>{formatDate(outDate)}</strong>
      </Typography>
      {returnedDate && (
        <Typography component={"div"}>
          {translate("returned")}: <strong>{formatDate(returnedDate)}</strong>
        </Typography>
      )}
    </LSResultItemLayout>
  );
};
